export const ONGOING_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    title: 'Assistência do Chatbot',
    inbox: {
      id: 2,
      name: 'Site PaperLayer',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Alexa Rivera',
    },
    message:
      'Olá! 👋 Precisa de ajuda com os recursos do nosso chatbot? Fique à vontade para perguntar!',
    campaign_status: 'ativo',
    enabled: true,
    campaign_type: 'em_andamento',
    trigger_rules: {
      url: 'https://www.omnigo.com/features/chatbot/',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: true,
    created_at: '2024-10-24T13:10:26.636Z',
    updated_at: '2024-10-24T13:10:26.636Z',
  },
  {
    id: 2,
    title: 'Suporte sobre Informações de Preços',
    inbox: {
      id: 2,
      name: 'Site PaperLayer',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Jamie Lee',
    },
    message: 'Olá! 👋 Alguma dúvida sobre preços? Estou aqui para ajudar!',
    campaign_status: 'ativo',
    enabled: false,
    campaign_type: 'em_andamento',
    trigger_rules: {
      url: 'https://www.omnigo.com/pricings',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:11:08.763Z',
    updated_at: '2024-10-24T13:11:08.763Z',
  },
  {
    id: 3,
    title: 'Assistência na Configuração do Produto',
    inbox: {
      id: 2,
      name: 'Site PaperLayer',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'OmniGO',
    },
    message:
      'Oi! Aqui é a OmniGO. Precisa de ajuda para configurar? É só avisar!',
    campaign_status: 'ativo',
    enabled: false,
    campaign_type: 'em_andamento',
    trigger_rules: {
      url: 'https://{*.}?omnigo.com/apps/account/*/settings/inboxes/new/',
      time_on_page: 10,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:11:44.285Z',
    updated_at: '2024-10-24T13:11:44.285Z',
  },
  {
    id: 4,
    title: 'Campanha de Assistência Geral',
    inbox: {
      id: 2,
      name: 'Site PaperLayer',
      channel_type: 'Channel::WebWidget',
      phone_number: '',
    },
    sender: {
      id: 1,
      name: 'Chris Barlow',
    },
    message:
      'Olá! 👋 Estou aqui para qualquer dúvida que você possa ter. Vamos conversar!',
    campaign_status: 'ativo',
    enabled: true,
    campaign_type: 'em_andamento',
    trigger_rules: {
      url: 'https://siv.com',
      time_on_page: 200,
    },
    trigger_only_during_business_hours: false,
    created_at: '2024-10-29T19:54:33.741Z',
    updated_at: '2024-10-29T19:56:26.296Z',
  },
];

export const ONE_OFF_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    title: 'Solicitação de Feedback',
    inbox: {
      id: 6,
      name: 'WhatsApp',
      channel_type: 'Channel::WhatsApp',
      phone_number: '+5511912345678',
      provider: 'default',
    },
    message:
      'Olá! Gostou do nosso produto? Envie seu feedback e ganhe um cupom de desconto: https://omnigo.app/g2-review',
    campaign_status: 'ativo',
    enabled: true,
    campaign_type: 'única',
    scheduled_at: 1729775588,
    audience: [
      { id: 4, type: 'Label' },
      { id: 5, type: 'Label' },
      { id: 6, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:13:08.496Z',
    updated_at: '2024-10-24T13:15:38.698Z',
  },
  {
    id: 2,
    title: 'Boas-vindas a Novo Cliente',
    inbox: {
      id: 6,
      name: 'PaperLayer Mobile',
      channel_type: 'Channel::Sms',
      phone_number: '+29818373149903',
      provider: 'default',
    },
    message: 'Bem-vindo(a)! 🎉 Avise se tiver alguma dúvida.',
    campaign_status: 'concluída',
    enabled: true,
    campaign_type: 'única',
    scheduled_at: 1729732500,
    audience: [
      { id: 1, type: 'Label' },
      { id: 6, type: 'Label' },
      { id: 5, type: 'Label' },
      { id: 2, type: 'Label' },
      { id: 4, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-24T13:14:00.168Z',
    updated_at: '2024-10-24T13:15:38.707Z',
  },
  {
    id: 3,
    title: 'Boas-vindas a Novo Parceiro de Negócio',
    inbox: {
      id: 6,
      name: 'PaperLayer Mobile',
      channel_type: 'Channel::Sms',
      phone_number: '+29818373149903',
      provider: 'default',
    },
    message: 'Olá! Estamos animados em ter sua empresa conosco!',
    campaign_status: 'ativo',
    enabled: true,
    campaign_type: 'única',
    scheduled_at: 1730368440,
    audience: [
      { id: 1, type: 'Label' },
      { id: 3, type: 'Label' },
      { id: 6, type: 'Label' },
      { id: 4, type: 'Label' },
      { id: 2, type: 'Label' },
      { id: 5, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-30T07:54:49.915Z',
    updated_at: '2024-10-30T07:54:49.915Z',
  },
  {
    id: 4,
    title: 'Integração de Novo Membro',
    inbox: {
      id: 6,
      name: 'PaperLayer Mobile',
      channel_type: 'Channel::Sms',
      phone_number: '+29818373149903',
      provider: 'default',
    },
    message: 'Bem-vindo(a) à equipe! Fale conosco se tiver dúvidas.',
    campaign_status: 'concluída',
    enabled: true,
    campaign_type: 'única',
    scheduled_at: 1730304840,
    audience: [
      { id: 1, type: 'Label' },
      { id: 3, type: 'Label' },
      { id: 6, type: 'Label' },
    ],
    trigger_rules: {},
    trigger_only_during_business_hours: false,
    created_at: '2024-10-29T16:14:10.374Z',
    updated_at: '2024-10-30T16:15:03.157Z',
  },
];
